import React from "react";
import { BsWallet } from "react-icons/bs";
import { FaGift } from "react-icons/fa";
import { MdFlashOn } from "react-icons/md";

import classes from "./ColsStyles.module.css";
import { getDownloadLink } from "../../utils/appLinks";

function Col1() {
  return (
    <div className={classes.main}>
      <div className={classes.data}>
        <span className={classes.eyebrow}>Weekly free rides</span>

        <h1>
          Running late? Catch a{" "}
          <span className={classes.highlight}>free ride</span> with
          Sprinterwave!
        </h1>

        <p>
          Don&apos;t miss a moment, download the Sprinterwave app today to
          enjoy free rides every week. Save more on errands, school runs, and
          weekend outings!
        </p>

        <div className={classes.flex_btm_box}>
          <div className={classes.box_1}>
            <i className={classes.iconChip} data-tone="amber">
              <MdFlashOn size={22} />
            </i>
            <h3>Fast Booking</h3>
            <p>
              Book a ride in seconds with Sprinterwave. No delays, no
              hassle—just tap, ride, and go!
            </p>
          </div>

          <div className={classes.box_1}>
            <i className={classes.iconChip} data-tone="green">
              <FaGift size={22} />
            </i>
            <h3>Free Rides</h3>
            <p>
              Enjoy your first ride on Sprinterwave! Take advantage of weekday
              promos with free rides every week.
            </p>
          </div>
        </div>

        <div className={classes.ctaRow}>
            <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer">
          <button className={classes.ctaButton}>
              Get the app →
          </button>
            </a>
          <span className={classes.ctaNote}>
            <BsWallet size={14} /> No card needed to claim
          </span>
        </div>
      </div>

      <div className={classes.image_wrapper}>
        <div className={classes.floatingBadge}>
          <span className={classes.dot} />
          Free ride unlocked
        </div>

        <img
          className={classes.imgBack}
          src="/images/ride/booking.png"
          alt="Booking a ride in the Sprinterwave app"
        />
        <img
          className={`${classes.imgFront} ${classes.slank}`}
          src="/images/ride/promotions.png"
          alt="Weekly ride promotions in the Sprinterwave app"
        />
      </div>
    </div>
  );
}

export default Col1;